export enum AppFieldsetArrangement {
    Vertical = 'vertical',
    Horizontal = 'horizontal',
}
